import styled from "styled-components";

export const DivAlignCenterWithOverflow = styled.div<{
    fixed?: boolean;
}>`
    display: flex;
    align-items: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    ${(props) => props.fixed ? `
        position: absolute;
        left: -2px;
        background: var(--li-header-color);
        width: 17.5rem;
        min-height: 24px;
        @media(max-width: 600px){ width: 13rem !important; }
        @media(max-width: 400px){ width: 11rem !important; }
    ` : ""}
`;

interface IsBold{
    bold?: boolean;
    red?: boolean;
    green?: boolean;
    purple?: boolean;
}

export const OverflowSpan = styled.span<IsBold>`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    ${(props) => props.bold ? "font-weight: bold;" : ""}
    ${(props) => props.red ? "color: var(--red);" : ""}
    ${(props) => props.green ? "color: var(--green);" : ""}
    ${(props) => props.purple ? "color: var(--purple);" : ""}
`;

export const DivValues = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    /* overflow-x: hidden; 
    overflow-y: hidden;  */
    position: relative;

    transition: 200ms ease;

    .arrowLeft-query-budget-values,
    .arrowRight-query-budget-values{
        display: flex;
        opacity: 0.25;
    }

    &:hover{
        .arrowLeft-query-budget-values,
        .arrowRight-query-budget-values{
            display: flex;
            opacity: 0.5;
            cursor: pointer;
        }
    }

    @media(max-width: 599px){
        .arrowLeft-query-budget-values,
        .arrowRight-query-budget-values{
            display: flex;
            opacity: 0.75;
            cursor: pointer;
        }
    }
`;

export const DivFlexMaxWidth = styled.div`
    display: flex; 
    flex-direction: column;
    width: 100%;
    
    overflow-y: hidden;
    overflow-x: auto;
`;

export const TD = styled.div`
    width: 112px;
    min-width: 112px;
    max-width: 112px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
    padding: 4px 2px;

    position: relative;

	color: var(--default-color-font);
	/* background-color: var(--progress-background); */

    &.value-predicted{
        background: var(--jexcel-header-footer);
    }
    &.value-realized{
        background:  var(--li-child-color);
    }
    &.value-last-year{
        background: var(--jexcel-header-footer);
    }
    &.value-variation-value{
        background: var(--jexcel-row-not-striped);
    }
    &.value-variation-percent{
        background: var(--li-header-color);
    }
    user-select: none;
    >span{
        z-index: 1;
    }

    @media(max-width: 450px){
        width: 84px;
        min-width: 84px;
        max-width: 84px; 
    }
`;

interface IDivColumn{
    alignStart?: boolean;
    fixed?: boolean;
    isHeader?: boolean;
}

export const DivColumn = styled.div<IDivColumn>`
    display: flex; 
    flex-direction: column; 
    align-items: flex-end;
    small{
        font-size: 0.65rem;
    }
    ${(props) => props.alignStart ? "align-items: flex-start;" : ""}
    ${(props) => props.fixed ? `
        position: absolute;
        left: -2px;
        background: var(--li-header-color);
        width: 17.5rem;
        min-height: 24px;
        @media(max-width: 600px){ width: 13rem !important; }
        @media(max-width: 400px){ width: 11rem !important; }
    ` : ""}
    ${(props) => props.isHeader ? `
        top: 2px;
    ` : ""}
`;
